import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { LivenessResult } from "../../../model/face.model";

import { HttpService } from "../http.service";

@Injectable({
  providedIn: "root",
})
export class FaceService extends HttpService {
  constructor(private _http: HttpClient) {
    super(_http);
  }

  public checkQuality(data: { file: string, token: string, url: string }): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + data.token);
    const url = data.url + "/api/image/quality?operation=CREATE";
    let dataToSend = new FormData();
    dataToSend.append("faceImage", data.file);
    return this._http.post<any>(url, dataToSend, { headers });
  }

  public detectFace(data: { idImage: File, token: string, url: string }): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + data.token);
    const newUrl = data.url + "/api/face/detect";
    let dataToSend = new FormData();
    dataToSend.append("picture", data.idImage);
    return this._http.post<any>(newUrl, dataToSend, { headers });
  }

  public matchPad(padId: string, probe: File, token: string, url: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.append("Authorization", "Bearer " + token);
    const newUrl = url + "/api/face/match/pad/" + padId + "/picture";
    let dataToSend = new FormData();
    dataToSend.append("probe", probe);
    return this._http.post<any>(newUrl, dataToSend, { headers });

  }

  public getLivenessProof(
    faceToken: any,
    faceUrl: any,
    livnessToken: any
  ): Observable<LivenessResult> {
    let headers = new HttpHeaders();
    headers = headers.append("Accept", "application/json");

    headers = headers.append("Authorization", "Bearer " + faceToken);

    // We want to get both the final picture and the proof sequence.
    const url =
      faceUrl + "/api/liveness/" + livnessToken + "?proof=true&picture=true";
    return this._http.get<LivenessResult>(url, { headers });
  }
}
